import React from 'react';
import AnalyticsManager from '../../../../app/analytics';
import { getMediaPath } from '../../../../app/functions';
import DynamicLink from '../../../../components/dynamic_link';
import './index.scss';

const MegaMenuAction = ({ text, image, link }) => {
    const handleActionClick = () => AnalyticsManager.logMenuItemPress(text);

    return (
        <DynamicLink data={link} onClick={handleActionClick}>
            <div className="mega-menu-action-wrapper">
                <div className="text">
                    {text}
                </div>

                <img src={getMediaPath(image)} alt="/" className="image"/>
            </div>
        </DynamicLink>
    );
};

export default MegaMenuAction;
